export function isNotNull<T>(value: T): value is Exclude<T, null> {
	return value !== null;
}

export function isNotUndefined<T>(value: T): value is Exclude<T, undefined> {
	return value !== undefined;
}

export function isNotNullOrUndefined<T>(value: T): value is Exclude<T, undefined | null> {
	return value !== undefined && value !== null;
}
